import { ProjectSearchDto } from '../../types';
import { ProjectOptionValue } from './LoadProjectsDropdown.types';

export const WITHOUT_ACCOUNT_LABEL = 'Without account';
export const PAGE_SIZE = 200;

export const isProjectOptionValue = (item: unknown): item is ProjectOptionValue => {
  if (!item || typeof item !== 'object') {
    return false;
  }

  const value = item as Record<string, unknown>;
  return typeof value.name === 'string' && 'id' in value;
};

export const getOptionId = (value: ProjectOptionValue) => String(value.id);

export const getAccountId = (project: ProjectSearchDto) => project.accountId || WITHOUT_ACCOUNT_LABEL;

export const compareAccounts = (
  [accountIdA]: [string, ProjectSearchDto[]],
  [accountIdB]: [string, ProjectSearchDto[]],
) => {
  if (accountIdA === WITHOUT_ACCOUNT_LABEL) return 1;
  if (accountIdB === WITHOUT_ACCOUNT_LABEL) return -1;
  return accountIdA.localeCompare(accountIdB);
};
